import React, { type FC } from "react";

import { Icon } from "../../../../Icon";

import type { IconProps } from "../../../../Icon";

import classes from "./ChipIcon.styl";

interface IChipIcon {
    size?: IconProps["size"];
    icon?: IconProps["icon"];
}

const CHIP_CHOICE_ICON_TEST_ID = "chip-choice-icon-test-id";

const ChipIcon: FC<IChipIcon> = (props) => {
    return (
        <Icon
            className={classes["icon"]}
            {...(props as IconProps)}
            data-tsid={CHIP_CHOICE_ICON_TEST_ID}
        />
    );
};

/* eslint-disable ok-custom-rules/check-attribute */
// Т.к. выше передаем data-tsid
export const MainIcon: FC<IChipIcon> = (props) => {
    return <ChipIcon {...props} />;
};

MainIcon.displayName = "ChipChoice.MainIcon";

export const LeftIcon: FC<IChipIcon> = (props) => {
    return <ChipIcon {...props} />;
};

LeftIcon.displayName = "ChipChoice.LeftIcon";

export const RightIcon: FC<IChipIcon> = (props) => {
    return <ChipIcon {...props} />;
};

RightIcon.displayName = "ChipChoice.RightIcon";
